(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('RetailCtrl', retailCtrl);

    function retailCtrl($scope, $routeParams, $window) {
        const url = new URL('/public/api/collective', process.env.VUE_APP_SHOPIFY_PRODUCT_PERSONALIZER_BASE_URL);
        const supplierStore = $routeParams.store;

        fetch(url.toString(), {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                supplierStore: supplierStore ? String(supplierStore) : undefined
            })
        })
            .catch(angular.noop)
            .finally(function () {
                setTimeout(function () {
                    // Keep incoming query params for GTM tracking, add retail marker
                    const search = window.location.search || '';
                    const join = search ? `${search}&` : '?';
                    $window.location.href = `https://apps.shopify.com/customily-product-personalizer${join}retail=1`;
                }, 500);
            });
    }
})();
